<template>
    <div class="grid grid-cols-1 md:grid-cols-2 h-full bg-gray">
        <div class="h-40 md:h-full md:min-h-screen md:max-h-full overflow-hidden relative">
            <img src="../assets/login-image.jpg" alt="Sharp - Be Original" class="hidden md:block w-full h-full object-cover object-left h-full" loading="lazy" />
            <img src="../assets/login-image-mobile.jpg" alt="Sharp - Be Original" class="block md:hidden w-full h-full object-cover object-left" loading="lazy" />
            <div class="mobile-logo-container absolute top-8 left-8 md:hidden">
                <img src="../assets/sharp-logo.png" alt="Sharp - Be Original" class="logo--white"/>
            </div>
        </div>

        <div class="md:min-h-screen md:order-first h-screen-40">
            <div class="md:w-96 page-container--home mx-auto md:mt-24 sc:mt-0 py-10 md:py-5  px-8 md:px-5">
                <div class="">
                    <div class="mb-16 hidden md:block">
                        <img src="../assets/sharp-logo.png" alt="Sharp - Be Original"/>
                    </div>
                    <div class="mb-16 md:mb-20">
                        <h1 class="mb-5 md:mb-10">Customer Portal Login</h1>
                        <login-form></login-form>
                    </div>
                    <div class="mb-8">
                        <div class="mb-3">
                            No account? Try Quick Access
                        </div>
                        <router-link :to="{ name: 'autologin' }" class="btn btn--gray-outline block">
                            Quick Access
                        </router-link>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script charset="utf-8">

import LoginForm from './form/LoginForm.vue'
import Vuex from 'vuex';

export default {
    created() {
        this.logoutEquipment();
        this.clearCurrentItem();
        if (this.profile.check()) {
            if(this.profile.isUser()){
                this.$router.push({ name: 'dashboard' });
            }else{
                this.$router.push({ name: 'adminClients' });
            }
        }
    },

    components: {
        LoginForm,
    },

    computed: {
        ...Vuex.mapGetters('profile', {
            profile: 'profile'
        }),
    },

    methods: {
        ...Vuex.mapActions('equipments', {
            clearCurrentItem: 'clearCurrentItem',

        }),
        ...Vuex.mapMutations('profile', {
            logoutEquipment: 'logoutEquipment'
        }),
    }
}
</script>
